/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type { Daonation, DaonationInterface } from "../../contracts/Daonation";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ERC20",
        name: "_votationToken",
        type: "address",
      },
      {
        internalType: "contract ERC20",
        name: "_donationToken",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_votationPeriod",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "_tokensToCreateProposal",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_proposalLockPeriod",
        type: "uint64",
      },
      {
        internalType: "uint16",
        name: "_votationTokenRewardRatio",
        type: "uint16",
      },
      {
        internalType: "uint64",
        name: "_donationPeriod",
        type: "uint64",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "donor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "donationToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "donationAmount",
        type: "uint256",
      },
    ],
    name: "Donation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "donationsTo",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "donationsAmount",
        type: "uint256",
      },
    ],
    name: "DonationRedeemed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardsAmount",
        type: "uint256",
      },
    ],
    name: "RewardsAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "unlockedAmount",
        type: "uint256",
      },
    ],
    name: "UnlockedTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
    ],
    name: "VaquinhaProposalCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokensUsed",
        type: "uint256",
      },
    ],
    name: "VoteAgainstVaquinha",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokensUsed",
        type: "uint256",
      },
    ],
    name: "VoteForVaquinha",
    type: "event",
  },
  {
    inputs: [],
    name: "UNIT_REWARD_RATIO",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "rewardsAmount",
        type: "uint256",
      },
    ],
    name: "addGovernanceTokenRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "availableRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "donationAmount",
        type: "uint256",
      },
    ],
    name: "donate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "donationPeriod",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "donationToken",
    outputs: [
      {
        internalType: "contract ERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
    ],
    name: "isDonating",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
    ],
    name: "isFinished",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
    ],
    name: "isVoting",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalLockPeriod",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "expectedValue",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "donationsTo",
        type: "address",
      },
    ],
    name: "proposeVaquinha",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
    ],
    name: "redeemDonations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tokensToCreateProposal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
    ],
    name: "unlockTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "vaquinhaByProposal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "vaquinhas",
    outputs: [
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "expectedValue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "votationEndTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "donationEndTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "aprovadores",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "detratores",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "donations",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "donationsTo",
        type: "address",
      },
      {
        internalType: "bool",
        name: "donationsRedeemed",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vaquinhasCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votationPeriod",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votationToken",
    outputs: [
      {
        internalType: "contract ERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votationTokenRewardRatio",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokensToUse",
        type: "uint256",
      },
    ],
    name: "voteAgainstVaquinha",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vaquinhaId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokensToUse",
        type: "uint256",
      },
    ],
    name: "voteForVaquinha",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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__$96689046c556a616eb827dad5094d6cda4$__90635de3fdfe9060240160206040518083038186803b15801561039657600080fd5b505af41580156103aa573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906103ce91906115a5565b6103f35760405162461bcd60e51b81526004016103ea906115c7565b60405180910390fd5b6103fd8383610e69565b81816004016000828254610411919061160a565b909155505060405182815283907fd877a0ffaf3ceb3e3eae621177d6a46d96975f59e4fd63e95f726dc6d72e980a906020015b60405180910390a2505050565b6000600683815481106104665761046661158f565b6000918252602090912060405163026b430d60e11b815260089092020160048201819052915073__$96689046c556a616eb827dad5094d6cda4$__906304d6861a9060240160206040518083038186803b1580156104c357600080fd5b505af41580156104d7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906104fb91906115a5565b61053d5760405162461bcd60e51b81526020600482015260136024820152724e4f5420444f4e4154494e472053544154555360681b60448201526064016103ea565b81816006016000828254610551919061160a565b909155505060015461056e906001600160a01b0316333085610eb3565b600854600090612710906105869061ffff1685611622565b6105909190611641565b905060095481116105a157806105a5565b6009545b9050806105b25750505050565b6000546105c9906001600160a01b03163383610f24565b80600960008282546105db9190611663565b9091555050600154604051339186917f7773fc95b186c7acac35717e017b7ee38507e308f89f4b02be43bf6e98778b1091610623916001600160a01b0390911690889061167a565b60405180910390a350505050565b6000600682815481106106465761064661158f565b60009182526020909120604051635f33349960e01b815260089092020160048201819052915073__$96689046c556a616eb827dad5094d6cda4$__90635f3334999060240160206040518083038186803b1580156106a357600080fd5b505af41580156106b7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106db91906115a5565b61071d5760405162461bcd60e51b81526020600482015260136024820152724e4f542046494e49534845442053544154555360681b60448201526064016103ea565b60078101546001600160a01b0316331461076b5760405162461bcd60e51b815260206004820152600f60248201526e4e4f542042454e454649434941525960881b60448201526064016103ea565b6007810154600160a01b900460ff16156107c45760405162461bcd60e51b815260206004820152601a6024820152791113d390551253d394c81053149150511648149151115153515160321b60448201526064016103ea565b60008160060154116108075760405162461bcd60e51b815260206004820152600c60248201526b4e4f20444f4e4154494f4e5360a01b60448201526064016103ea565b6007810154600682015460015461082c926001600160a01b0391821692911690610f24565b600781018054600160a01b60ff60a01b1982161790915560068201546040519081526001600160a01b039091169083907f61d5fe23200a376c28fd61cd169b5405a6147d26987700eab6d37d17b698c4979060200160405180910390a35050565b6000600682815481106108a2576108a261158f565b6000918252602090912060405163026b430d60e11b8152600890920201600482015273__$96689046c556a616eb827dad5094d6cda4$__906304d6861a906024015b60206040518083038186803b1580156108fc57600080fd5b505af4158015610910573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061093491906115a5565b92915050565b600054610952906001600160a01b0316333084610eb3565b8060096000828254610964919061160a565b90915550506040517fac140162a56e01aec90ea4ff6eea27f60ca53066fd39d57664700f1a8589de9a9061099b903390849061167a565b60405180910390a150565b6000600682815481106109bb576109bb61158f565b60009182526020909120604051632ef1feff60e11b815260089092020160048201819052915073__$96689046c556a616eb827dad5094d6cda4$__90635de3fdfe9060240160206040518083038186803b158015610a1857600080fd5b505af4158015610a2c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a5091906115a5565b15610a8f5760405162461bcd60e51b815260206004820152600f60248201526e1593d510551253d3881411549253d1608a1b60448201526064016103ea565b600082815260046020908152604080832033845290915290205480610aec5760405162461bcd60e51b81526020600482015260136024820152724e4f20544f4b454e5320544f20554e4c4f434b60681b60448201526064016103ea565b600054610b03906001600160a01b03163383610f24565b60008381526004602090815260408083203380855290835281842093909355518381527faf08a4db36432bb5cbbfdfcf5af1040246483dc0dae8a9616cc79816c432fee99101610444565b600060068381548110610b6357610b6361158f565b60009182526020909120604051632ef1feff60e11b815260089092020160048201819052915073__$96689046c556a616eb827dad5094d6cda4$__90635de3fdfe9060240160206040518083038186803b158015610bc057600080fd5b505af4158015610bd4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610bf891906115a5565b610c145760405162461bcd60e51b81526004016103ea906115c7565b610c1e8383610e69565b81816004016000828254610c32919061160a565b909155505060405182815283907ff47a75272b34986a8700be187f55af94b2a3bce0b5e2fa9ab69ed7430431a1af90602001610444565b600060068281548110610c7e57610c7e61158f565b60009182526020909120604051632ef1feff60e11b8152600890920201600482015273__$96689046c556a616eb827dad5094d6cda4$__90635de3fdfe906024016108e4565b60068181548110610cd457600080fd5b9060005260206000209060080201600091509050806000018054610cf790611693565b80601f0160208091040260200160405190810160405280929190818152602001828054610d2390611693565b8015610d705780601f10610d4557610100808354040283529160200191610d70565b820191906000526020600020905b815481529060010190602001808311610d5357829003601f168201915b5050505060018301546002840154600385015460048601546005870154600688015460079098015496979496939550919390926001600160a01b03811690600160a01b900460ff1689565b600060068281548110610dd057610dd061158f565b60009182526020909120604051635f33349960e01b8152600890920201600482015273__$96689046c556a616eb827dad5094d6cda4$__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";

type DaonationConstructorParams =
  | [linkLibraryAddresses: DaonationLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DaonationConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class Daonation__factory extends ContractFactory {
  constructor(...args: DaonationConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(
        _abi,
        Daonation__factory.linkBytecode(linkLibraryAddresses),
        signer
      );
    }
  }

  static linkBytecode(linkLibraryAddresses: DaonationLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$96689046c556a616eb827dad5094d6cda4\\$__", "g"),
      linkLibraryAddresses["contracts/VaquinhaLibrary.sol:VaquinhaLibrary"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  override deploy(
    _votationToken: PromiseOrValue<string>,
    _donationToken: PromiseOrValue<string>,
    _votationPeriod: PromiseOrValue<BigNumberish>,
    _tokensToCreateProposal: PromiseOrValue<BigNumberish>,
    _proposalLockPeriod: PromiseOrValue<BigNumberish>,
    _votationTokenRewardRatio: PromiseOrValue<BigNumberish>,
    _donationPeriod: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Daonation> {
    return super.deploy(
      _votationToken,
      _donationToken,
      _votationPeriod,
      _tokensToCreateProposal,
      _proposalLockPeriod,
      _votationTokenRewardRatio,
      _donationPeriod,
      overrides || {}
    ) as Promise<Daonation>;
  }
  override getDeployTransaction(
    _votationToken: PromiseOrValue<string>,
    _donationToken: PromiseOrValue<string>,
    _votationPeriod: PromiseOrValue<BigNumberish>,
    _tokensToCreateProposal: PromiseOrValue<BigNumberish>,
    _proposalLockPeriod: PromiseOrValue<BigNumberish>,
    _votationTokenRewardRatio: PromiseOrValue<BigNumberish>,
    _donationPeriod: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _votationToken,
      _donationToken,
      _votationPeriod,
      _tokensToCreateProposal,
      _proposalLockPeriod,
      _votationTokenRewardRatio,
      _donationPeriod,
      overrides || {}
    );
  }
  override attach(address: string): Daonation {
    return super.attach(address) as Daonation;
  }
  override connect(signer: Signer): Daonation__factory {
    return super.connect(signer) as Daonation__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DaonationInterface {
    return new utils.Interface(_abi) as DaonationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Daonation {
    return new Contract(address, _abi, signerOrProvider) as Daonation;
  }
}

export interface DaonationLibraryAddresses {
  ["contracts/VaquinhaLibrary.sol:VaquinhaLibrary"]: string;
}
